export const REPORT_NODE_TYPES = {
  COVER_PAGE: 'COVER_PAGE',
  ASSET_SECTION: 'ASSET_SECTION',
};

export const TEMPLATE_TYPES = {
  REPORT_TEMPLATE: 'reportTemplate',
  PROJECT_BLUEPRINT: 'projectBlueprint',
  TASK_LIST_TEMPLATE: 'taskListTemplate',
  COMPANY_DOCUMENT: 'documentBlueprint',
  PAGE_TEMPLATE: 'pageTemplate',
};
